export const TTS_GLOBAL_VOICE_SOURCE = [
  { id: 'English_Trustworthy_Man', name: 'Trustworthy Man', lang: 'en', urlPath: '024141-ykAHZ5Gj5FrKsFk1.mp3' },
  {
    id: 'English_Graceful_Lady',
    name: 'Graceful Lady',
    lang: 'en',
    urlPath: '023820-Rc4W9DngzHgkqG4O.mp3',
    description: '温润，舒缓，文学感',
  },
  { id: 'English_Aussie_Bloke', name: 'English_Aussie_Bloke', lang: 'en', urlPath: '023411-GkhTlWmTEizBXDeC.mp3' },
  { id: 'English_Whispering_girl', name: 'Whispering girl', lang: 'en', urlPath: '024141-JxvLB9335VE0IjSQ.mp3' },
  {
    id: 'English_Diligent_Man',
    name: 'Diligent Man',
    lang: 'en',
    urlPath: '023815-0gpJ51VbXEHysDok.mp3',
    description: '清脆明亮，轻快活泼，热情感染力',
  },
  {
    id: 'English_Gentle-voiced_man',
    name: 'Gentle-voiced Man',
    lang: 'en',
    urlPath: '023810-OIczMgcJeMuXt4ox.mp3',
    description: '醇厚深沉，娓娓道来，极具故事感',
  },
  {
    id: 'Chinese (Mandarin)_Reliable_Executive',
    name: '沉稳高管',
    lang: 'zh',
    urlPath: '023414-NT1Fo5dEKR7y1YNb.mp3',
    description: '低沉厚实，磁性，从容不迫',
  },
  {
    id: 'Chinese (Mandarin)_Mature_Woman',
    name: '傲娇御姐',
    lang: 'zh',
    urlPath: '023415-K2OANGlaoGv7Z9Mu.mp3',
    description: '低沉沙哑，慵懒舒缓，性感撩人',
  },
  {
    id: 'Chinese (Mandarin)_Unrestrained_Young_Man',
    name: '不羁青年',
    lang: 'zh',
    urlPath: '023414-IRd46Knb7EnQYOyZ.mp3',
    description: '低沉磁性，慵懒随意，霸道',
  },
  {
    id: 'Arrogant_Miss',
    name: '嚣张小姐',
    lang: 'zh',
    urlPath: '023415-Q2nAWrnYuHoTv2Ho.mp3',
    description: '娇俏明亮，灵动跳跃，傲娇自信',
  },
  {
    id: 'Robot_Armor',
    name: '机械战甲',
    lang: 'zh',
    urlPath: '023417-HaE3YVBeWdUMQ8s8.mp3',
    description: '金属质感，机械顿挫，科幻色彩',
  },
  {
    id: 'Chinese (Mandarin)_Kind-hearted_Antie',
    name: '热心大婶',
    lang: 'zh',
    urlPath: '023416-caabZ2KrZt5EYNFv.mp3',
    description: '高昂明亮，碎碎念，生活气息',
  },
  {
    id: 'Chinese (Mandarin)_Humorous_Elder',
    name: '搞笑大爷',
    lang: 'zh',
    urlPath: '023418-NHNrw2uZ1bYFqMRu.mp3',
    description: '沧桑醇厚，松弛接地气，幽默热心',
  },
  {
    id: 'Chinese (Mandarin)_Gentleman',
    name: '温润男声',
    lang: 'zh',
    urlPath: '023418-QvQnuK8Cbjj2y1Re.mp3',
    description: '温润清亮，娓娓道来，阳光自律',
  },
  {
    id: 'Chinese (Mandarin)_Warm_Bestie',
    name: '温暖闺蜜',
    lang: 'zh',
    urlPath: '023419-gziyqyZ5AwDD6IIr.mp3',
    description: '温柔清亮，舒缓且充满关切，亲切自然',
  },
  {
    id: 'Chinese (Mandarin)_Male_Announcer',
    name: '播报男声',
    lang: 'zh',
    urlPath: '023425-ErVDk5tX6LU5fOUi.mp3',
    description: '清澈干净，自然流畅，邻家大哥哥',
  },
  {
    id: 'Chinese (Mandarin)_Sweet_Lady',
    name: '甜美女声',
    lang: 'zh',
    urlPath: '023420-THUpPCrSSbNuHxmo.mp3',
    description: '甜美细腻，舒缓自然，邻家亲切感',
  },
  {
    id: 'Chinese (Mandarin)_Southern_Young_Man',
    name: '南方小哥',
    lang: 'zh',
    urlPath: '023421-3AD7CT6c0Sg7Emd3.mp3',
    description: '温润细腻，娓娓道来，亲切邻家',
  },
  {
    id: 'Chinese (Mandarin)_Wise_Women',
    name: '阅历姐姐',
    lang: 'zh',
    urlPath: '023422-Uw5oYslEl5bcaNIb.mp3',
    description: '温润厚实，娓娓道来，极具亲和力',
  },
  {
    id: 'Chinese (Mandarin)_Gentle_Youth',
    name: '温润青年',
    lang: 'zh',
    urlPath: '023424-6dF29ALAOi3v78xE.mp3',
    description: '清亮干净，娓娓道来，邻家大哥哥',
  },
  {
    id: 'Chinese (Mandarin)_Warm_Girl',
    name: '温暖少女',
    lang: 'zh',
    urlPath: '023425-iqB1ZRFaXUEzuUII.mp3',
    description: '甜美细腻，娓娓道来，治愈感',
  },
  {
    id: 'Chinese (Mandarin)_Kind-hearted_Elder',
    name: '花甲奶奶',
    lang: 'zh',
    urlPath: '023426-WbSCLZ8l0TzxAsCy.mp3',
    description: '略带沙哑，娓娓道来，极具亲和力',
  },
  {
    id: 'Chinese (Mandarin)_Cute_Spirit',
    name: '憨憨萌兽',
    lang: 'zh',
    urlPath: '023427-O5eGdBJG9UxSx7aS.mp3',
    description: '软萌稚嫩，轻快活泼，天真烂漫',
  },
  {
    id: 'Chinese (Mandarin)_Radio_Host',
    name: '电台男主播',
    lang: 'zh',
    urlPath: '023427-dY8FHcwcnoLsCpIw.mp3',
    description: '清亮明快，干脆利落，略带傲娇',
  },
  {
    id: 'Chinese (Mandarin)_Lyrical_Voice',
    name: '抒情男声',
    lang: 'zh',
    urlPath: '023428-KTJCzq8Td4y2bf1l.mp3',
    description: '温润醇厚，娓娓道来，治愈感',
  },
  {
    id: 'Chinese (Mandarin)_Straightforward_Boy',
    name: '率真弟弟',
    lang: 'zh',
    urlPath: '023428-xpvvp2VcplJpGFwr.mp3',
    description: '明朗干净，直率自然，邻家少年',
  },
  {
    id: 'Chinese (Mandarin)_Sincere_Adult',
    name: '真诚青年',
    lang: 'zh',
    urlPath: '023429-SlpXcIWfKGk2trFr.mp3',
    description: '清澈干净，娓娓道来，具有治愈感',
  },
  {
    id: 'Chinese (Mandarin)_Gentle_Senior',
    name: '温柔学姐',
    lang: 'zh',
    urlPath: '023430-GlDX7xiVWFlgamgz.mp3',
    description: '温婉柔和，娓娓道来，亲切且富有感染力',
  },
  {
    id: 'Chinese (Mandarin)_Stubborn_Friend',
    name: '嘴硬竹马',
    lang: 'zh',
    urlPath: '023420-zaFAZXPj1HXZCSDG.mp3',
    description: '清朗温暖，自然随性，邻家大男孩',
  },
  {
    id: 'Chinese (Mandarin)_Crisp_Girl',
    name: '清脆少女',
    lang: 'zh',
    urlPath: '023430-1xeFdiZf5m1D7HXV.mp3',
    description: '清脆甜美，娓娓道来，治愈亲切',
  },
  {
    id: 'Chinese (Mandarin)_Pure-hearted_Boy',
    name: '清澈邻家弟弟',
    lang: 'zh',
    urlPath: '023431-VZHCSxp08QrgL8q2.mp3',
    description: '清澈干净，娓娓道来，邻家男孩感',
  },
  {
    id: 'Chinese (Mandarin)_Soft_Girl',
    name: '软软女孩',
    lang: 'zh',
    urlPath: '023432-X73BUzBfaiO7aVIz.mp3',
    description: '甜美软糯，轻快自然，亲切活泼',
  },
  {
    id: 'Cantonese_ProfessionalHost（F)',
    name: '专业女主持',
    lang: 'zhYue',
    urlPath: '024023-X7rqoXvAOaFswGad.mp3',
    description: '清晰明亮，紧凑流畅，新闻现场感',
  },
  {
    id: 'Cantonese_GentleLady',
    name: '温柔女声',
    lang: 'zhYue',
    urlPath: '024024-x4McDcr3zCpgt0yQ.mp3',
    description: '略带沙哑，语速较快，直率自然',
  },
  {
    id: 'Cantonese_CuteGirl',
    name: '可爱女孩',
    lang: 'zhYue',
    urlPath: '024026-0s3J17LUekOBsqnt.mp3',
    description: '稚嫩甜美，灵动自然，纯真',
  },
  {
    id: 'Cantonese_KindWoman',
    name: '善良女声',
    lang: 'zhYue',
    urlPath: '024027-S1IKtPZGC28KZ6Is.mp3',
    description: '略带沙哑，娓娓道来，亲切犀利',
  },

  {
    id: 'Japanese_IntellectualSenior',
    name: 'Intellectual Senior',
    lang: 'ja',
    urlPath: '023408-5Q8w2Qj2E8zgdgJm.mp3',
    description: '清澈柔和，舒缓从容，宁静致远',
  },
  {
    id: 'Japanese_DecisivePrincess',
    name: 'Decisive Princess',
    lang: 'ja',
    urlPath: '023409-USuGahZ7YafZr6lG.mp3',
    description: '清脆透亮，节奏紧凑，傲娇严厉',
  },
  {
    id: 'Japanese_LoyalKnight',
    name: 'Loyal Knight',
    lang: 'ja',
    urlPath: '023656-mSQqDwzrGp8jKw0n.mp3',
    description: '清冷孤傲，干脆利落，守护者氛围',
  },
  {
    id: 'Japanese_DominantMan',
    name: 'Dominant Man',
    lang: 'ja',
    urlPath: '023658-oOKbqsULuOimVVgI.mp3',
    description: '质感冷冽，冷静克制，高冷',
  },
  {
    id: 'Japanese_SeriousCommander',
    name: 'Serious Commander',
    lang: 'ja',
    urlPath: '023659-j347k4a6nZDQt6eR.mp3',
    description: '温润清冷，优雅从容，神秘学者感',
  },
  {
    id: 'Japanese_ColdQueen',
    name: 'Cold Queen',
    lang: 'ja',
    urlPath: '023700-aYc61qVXfl9BVwBk.mp3',
    description: '低沉沙哑，慵懒随意，御姐气场',
  },
  {
    id: 'Japanese_DependableWoman',
    name: 'Dependable Woman',
    lang: 'ja',
    urlPath: '023701-cX0To7MsPP5A1Jqs.mp3',
    description: '清脆明亮，干脆利落，爽朗大方',
  },
  {
    id: 'Japanese_GentleButler',
    name: 'Gentle Butler',
    lang: 'ja',
    urlPath: '023702-X3l6yzFK6lJTzz1R.mp3',
    description: '磁性且略带慵懒，轻松自如，优雅而神秘',
  },
  {
    id: 'Japanese_KindLady',
    name: 'Kind Lady',
    lang: 'ja',
    urlPath: '023703-M0VPCoPZHCAa9oJE.mp3',
    description: '温柔妩媚，舒缓从容，知性御姐感',
  },
  {
    id: 'Japanese_CalmLady',
    name: 'Calm Lady',
    lang: 'ja',
    urlPath: '023703-VjVW572W6cPf88Rc.mp3',
    description: '清冷优雅，从容不迫，高贵自信',
  },
  {
    id: 'Japanese_OptimisticYouth',
    name: 'Optimistic Youth',
    lang: 'ja',
    urlPath: '023704-uJaUXpzScywud1tn.mp3',
    description: '清爽明快，充满活力，阳光少年形象',
  },
  {
    id: 'Japanese_GenerousIzakayaOwner',
    name: 'Generous Izakaya Owner',
    lang: 'ja',
    urlPath: '023705-QszlkEAYpwPnQJWa.mp3',
    description: '豪爽沙哑，激情高昂，自信热血',
  },
  {
    id: 'Japanese_SportyStudent',
    name: 'Sporty Student',
    lang: 'ja',
    urlPath: '023708-GyNvbHyJO2vbjVPY.mp3',
    description: '清亮朝气，干脆利落，自信飞扬',
  },
  {
    id: 'Japanese_InnocentBoy',
    name: 'Innocent Boy',
    lang: 'ja',
    urlPath: '023712-yBMCsLe1BJYTNabx.mp3',
    description: '清澈纯净，温和礼貌，少年感',
  },
  {
    id: 'Japanese_GracefulMaiden',
    name: 'Graceful Maiden',
    lang: 'ja',
    urlPath: '023713-XUrDUGSNHKSrTv5o.mp3',
    description: '清澈柔和，舒缓有礼，治愈且知性',
  },
  {
    id: 'Korean_SweetGirl',
    name: 'Sweet Girl',
    lang: 'ko',
    urlPath: '023446-9hYpGais3u6stEFt.mp3',
    description: '清脆甜美，轻快活泼，热情且富有感染力',
  },
  {
    id: 'Korean_CheerfulBoyfriend',
    name: 'Cheerful Boyfriend',
    lang: 'ko',
    urlPath: '023447-Vudod2Eobdtw6bp6.mp3',
    description: '清亮干净，轻快跃动，温暖阳光',
  },
  {
    id: 'Korean_EnchantingSister',
    name: 'Enchanting Sister',
    lang: 'ko',
    urlPath: '023448-oej3SQWS8HNiABri.mp3',
    description: '极富磁性，从容自信，高冷威严',
  },
  {
    id: 'Korean_ShyGirl',
    name: 'Shy Girl',
    lang: 'ko',
    urlPath: '023448-EmwiipkUVhDg6VkJ.mp3',
    description: '细腻气声，轻柔舒缓，邻家少女感',
  },
  {
    id: 'Korean_ReliableSister',
    name: 'Reliable Sister',
    lang: 'ko',
    urlPath: '023449-BZIRztfHlmseYtNM.mp3',
    description: '干练沙哑，干脆利落，酷飒御姐感',
  },
  {
    id: 'Korean_StrictBoss',
    name: 'Strict Boss',
    lang: 'ko',
    urlPath: '023450-dlsoNhksXtQyvFEs.mp3',
    description: '清亮透彻，抑扬顿挫，王者气场',
  },
  {
    id: 'Korean_SassyGirl',
    name: 'Sassy Girl',
    lang: 'ko',
    urlPath: '023450-QFSeMm0P9mzd01j4.mp3',
    description: '甜美娇俏，轻快跳跃，元气满满',
  },
  {
    id: 'Korean_ChildhoodFriendGirl',
    name: 'Childhood Friend Girl',
    lang: 'ko',
    urlPath: '023451-lYSqJb2PgGgEFELX.mp3',
    description: '明亮沙哑，干练利落，自信俏皮',
  },
  {
    id: 'Korean_PlayboyCharmer',
    name: 'Playboy Charmer',
    lang: 'ko',
    urlPath: '023452-Tsou8HBbX615Vmer.mp3',
    description: '慵懒磁性，轻快流畅，极具撩拨感',
  },
  {
    id: 'Korean_ElegantPrincess',
    name: 'Elegant Princess',
    lang: 'ko',
    urlPath: '023452-X46uHBBlgasicFoQ.mp3',
    description: '清冷高贵，干练利落，威严自信',
  },
  {
    id: 'Korean_BraveFemaleWarrior',
    name: 'Brave Female Warrior',
    lang: 'ko',
    urlPath: '023453-6PzJj2FNzCgeYC6L.mp3',
    description: '清亮凛冽，干脆利落，领袖风范',
  },
  {
    id: 'Korean_BraveYouth',
    name: 'Brave Youth',
    lang: 'ko',
    urlPath: '023453-NShrvIGyDdbeO1Lj.mp3',
    description: '清朗明快，轻快跳跃，恋爱氛围感',
  },
  {
    id: 'Korean_CalmLady',
    name: 'Calm Lady',
    lang: 'ko',
    urlPath: '023454-UDHZb6W2my4YIqz0.mp3',
    description: '清冷优雅，沉稳内敛，威严冷静',
  },
  {
    id: 'Korean_EnthusiasticTeen',
    name: 'Enthusiastic Teen',
    lang: 'ko',
    urlPath: '023454-P6XbKpSM4sx0foIx.mp3',
    description: '清亮高亢，急促有力，少年英雄感',
  },
  {
    id: 'Korean_SoothingLady',
    name: 'Soothing Lady',
    lang: 'ko',
    urlPath: '023455-JXyySExZ37jYpUlw.mp3',
    description: '温柔慵懒，舒缓流畅，亲切迷人',
  },
  {
    id: 'Korean_IntellectualSenior',
    name: 'Intellectual Senior',
    lang: 'ko',
    urlPath: '023456-lYzIEvmWtEzJ0CtR.mp3',
    description: '温润清澈，舒缓从容，淡然诗意',
  },
  {
    id: 'Korean_LonelyWarrior',
    name: 'Lonely Warrior',
    lang: 'ko',
    urlPath: '023456-nUNlm9tFqP4JCzLl.mp3',
    description: '略带沙哑，干脆利落，冷峻魅力',
  },
  {
    id: 'Korean_MatureLady',
    name: 'Mature Lady',
    lang: 'ko',
    urlPath: '023457-WDvaUUiofTrwl7Rt.mp3',
    description: '冷艳锐利，果断傲慢，自信轻蔑',
  },
  {
    id: 'Korean_InnocentBoy',
    name: 'Innocent Boy',
    lang: 'ko',
    urlPath: '023457-SWxyL0tthOCZzOsC.mp3',
    description: '清澈稚嫩，温柔诚恳，乖巧少年',
  },
  {
    id: 'Korean_CharmingSister',
    name: 'Charming Sister',
    lang: 'ko',
    urlPath: '023458-lyw2x1h1NPXqEFZa.mp3',
    description: '低沉略带沙哑，自信且充满压迫感，危险迷人',
  },
  {
    id: 'Korean_AthleticStudent',
    name: 'Athletic Student',
    lang: 'ko',
    urlPath: '023459-vbORXpkZASvM4sJu.mp3',
    description: '明亮高亢，干脆利落，热血激昂',
  },
  {
    id: 'Korean_BraveAdventurer',
    name: 'Brave Adventurer',
    lang: 'ko',
    urlPath: '023459-Nd7gjThL5jEvq3Ai.mp3',
    description: '清脆明亮，灵动活泼，顽皮乐观',
  },
  {
    id: 'Korean_CalmGentleman',
    name: 'Calm Gentleman',
    lang: 'ko',
    urlPath: '023500-9arBMjblSxeN4l7B.mp3',
    description: '低沉优雅，从容不迫，充满故事感',
  },
  {
    id: 'Korean_WiseElf',
    name: 'Wise Elf',
    lang: 'ko',
    urlPath: '023501-7unTKr6TrbCw5hLg.mp3',
    description: '温柔细腻，舒缓轻柔，认真羞涩',
  },
  {
    id: 'Korean_CheerfulCoolJunior',
    name: 'Cheerful Cool Junior',
    lang: 'ko',
    urlPath: '023501-cIiQVI7M91Otx2LP.mp3',
    description: '清亮爽朗，自信轻快，热血无畏',
  },
  {
    id: 'Korean_DecisiveQueen',
    name: 'Decisive Queen',
    lang: 'ko',
    urlPath: '023502-eykXtRNN0qbKEv1k.mp3',
    description: '清脆明亮，干脆利落，强气自信',
  },
  {
    id: 'Korean_ColdYoungMan',
    name: 'Cold Young Man',
    lang: 'ko',
    urlPath: '023502-3d16ZKMp1n7BQYft.mp3',
    description: '清冷清澈，娓娓道来，冷静且克制',
  },
  {
    id: 'Korean_MysteriousGirl',
    name: 'Mysterious Girl',
    lang: 'ko',
    urlPath: '023503-0c8pQLAsYF6KRhIl.mp3',
    description: '甜美高亢，干脆利落，元气满满',
  },
  {
    id: 'Korean_QuirkyGirl',
    name: 'Quirky Girl',
    lang: 'ko',
    urlPath: '023504-45MUyRZ4dkCRgwkO.mp3',
    description: '清脆明亮，轻快跳跃，元气少女感',
  },
  {
    id: 'Korean_ConsiderateSenior',
    name: 'Considerate Senior',
    lang: 'ko',
    urlPath: '023504-Tv94aqW176stL6Ur.mp3',
    description: '温暖厚实，舒缓从容，关怀感',
  },
  {
    id: 'Korean_CheerfulLittleSister',
    name: 'Cheerful Little Sister',
    lang: 'ko',
    urlPath: '023505-0Q6PEhxE8yOmf8X6.mp3',
    description: '清脆明亮，语速轻快活泼，热情亲切',
  },
  {
    id: 'Korean_DominantMan',
    name: 'Dominant Man',
    lang: 'ko',
    urlPath: '023506-o8Mbbc35qL1PiTyP.mp3',
    description: '冷峻低沉，沉稳克制，高冷贵公子',
  },
  {
    id: 'Korean_AirheadedGirl',
    name: 'Airheaded Girl',
    lang: 'ko',
    urlPath: '023506-6YqYL4yreePwcLeL.mp3',
    description: '清脆明亮，干脆利落，傲娇感',
  },
  {
    id: 'Korean_ReliableYouth',
    name: 'Reliable Youth',
    lang: 'ko',
    urlPath: '023507-3o6yOPNfKRt2phsO.mp3',
    description: '干净纯粹，干脆利落，正气凛然',
  },
  {
    id: 'Korean_FriendlyBigSister',
    name: 'Friendly Big Sister',
    lang: 'ko',
    urlPath: '023508-0FQWyIwAiS4rnZQS.mp3',
    description: '略带沙哑，自信从容，极具诱惑力',
  },
  {
    id: 'Korean_GentleBoss',
    name: 'Gentle Boss',
    lang: 'ko',
    urlPath: '023509-HcYqDMBJqop5wyaE.mp3',
    description: '阴冷沙哑，阴狠果断，黑暗压迫感',
  },
  {
    id: 'Korean_ColdGirl',
    name: 'Cold Girl',
    lang: 'ko',
    urlPath: '023510-0vqFL6tbZdx3UwIL.mp3',
    description: '轻柔慵懒，缓慢拖沓，淡漠疏离',
  },
  {
    id: 'Korean_HaughtyLady',
    name: 'Haughty Lady',
    lang: 'ko',
    urlPath: '023510-S447ROc59SPbnOGC.mp3',
    description: '通透澄澈，不紧不慢，孤傲神秘',
  },
  {
    id: 'Korean_CharmingElderSister',
    name: 'Charming Elder Sister',
    lang: 'ko',
    urlPath: '023511-xFAgtQjbuuv5ZcTy.mp3',
    description: '华丽优雅，从容不迫，神秘且撩人',
  },
  {
    id: 'Korean_IntellectualMan',
    name: 'Intellectual Man',
    lang: 'ko',
    urlPath: '023512-3NkUCe36rtbahnzU.mp3',
    description: '低沉醇厚，舒缓慵懒，温柔亲昵',
  },
  {
    id: 'Korean_CaringWoman',
    name: 'Caring Woman',
    lang: 'ko',
    urlPath: '023512-JxuPDmsLN4hNDt4j.mp3',
    description: '清脆明亮，轻快活泼，俏皮可爱',
  },
  {
    id: 'Korean_WiseTeacher',
    name: 'Wise Teacher',
    lang: 'ko',
    urlPath: '023513-fomRYaKNtlKVaMbW.mp3',
    description: '清亮明快，干脆利落，运筹帷幄的傲气',
  },
  {
    id: 'Korean_ConfidentBoss',
    name: 'Confident Boss',
    lang: 'ko',
    urlPath: '023513-gFSOE1GDKDuruQzR.mp3',
    description: '沙哑磁性，从容不迫，幕后操纵感',
  },
  {
    id: 'Korean_AthleticGirl',
    name: 'Athletic Girl',
    lang: 'ko',
    urlPath: '023514-tolbH448BsQ8Yd4I.mp3',
    description: '清脆明亮，欢快跳跃，元气满满',
  },
  {
    id: 'Korean_PossessiveMan',
    name: 'Possessive Man',
    lang: 'ko',
    urlPath: '023515-SnfGMQtcyVnaMjYD.mp3',
    description: '冷冽富有磁性，从容不迫，高冷统领感',
  },
  {
    id: 'Korean_GentleWoman',
    name: 'Gentle Woman',
    lang: 'ko',
    urlPath: '023515-reU8qi1unwXdFzTh.mp3',
    description: '清澈温润，彬彬有礼，大家闺秀感',
  },
  {
    id: 'Korean_CockyGuy',
    name: 'Cocky Guy',
    lang: 'ko',
    urlPath: '023516-68LRl2BQhxjtCEXQ.mp3',
    description: '中气十足，极具爆发力，狂妄感',
  },
  {
    id: 'Korean_ThoughtfulWoman',
    name: 'Thoughtful Woman',
    lang: 'ko',
    urlPath: '023516-VrPhmoTbcfQluP9T.mp3',
    description: '清脆明亮，轻快活泼，亲切可爱',
  },
  {
    id: 'Korean_OptimisticYouth',
    name: 'Optimistic Youth',
    lang: 'ko',
    urlPath: '023517-Eik3iSeINnN8Pih4.mp3',
    description: '清亮，轻快活泼，元气满满',
  },
  {
    id: 'Spanish_SereneWoman',
    name: 'Serene Woman',
    lang: 'es',
    urlPath: '023536-y0uoFjDEOazu7soN.mp3',
    description: '明亮清脆，灵活多变，生动活泼',
  },
  {
    id: 'Spanish_MaturePartner',
    name: 'Mature Partner',
    lang: 'es',
    urlPath: '023537-16f405gqSIznKuSd.mp3',
    description: '粗犷沙哑，慵懒随意，历经沧桑',
  },
  {
    id: 'Spanish_CaptivatingStoryteller',
    name: 'Captivating Storyteller',
    lang: 'es',
    urlPath: '023538-wj98zXR6VBAyPxh0.mp3',
    description: '深沉厚重，娓娓道来，历史厚重感',
  },
  {
    id: 'Spanish_Narrator',
    name: 'Narrator',
    lang: 'es',
    urlPath: '023538-H8dsGCphGgFWUddt.mp3',
    description: '热情洋溢，夸张戏剧化，慈祥母亲角色',
  },
  {
    id: 'Spanish_WiseScholar',
    name: 'Wise Scholar',
    lang: 'es',
    urlPath: '023539-RgdeCufacaQEnhCT.mp3',
    description: '清亮质朴，如话家常，邻家男孩',
  },
  {
    id: 'Spanish_Kind-heartedGirl',
    name: 'Kind-hearted Girl',
    lang: 'es',
    urlPath: '023539-ICXDs1Vx7uNElvgE.mp3',
    description: '甜美清亮，轻快活泼，邻家亲切感',
  },
  {
    id: 'Spanish_DeterminedManager',
    name: 'Determined Manager',
    lang: 'es',
    urlPath: '023540-rKQRhugm4fk7Ahgb.mp3',
    description: '锐利坚定，字字铿锵，充满压迫感',
  },
  {
    id: 'Spanish_BossyLeader',
    name: 'Bossy Leader',
    lang: 'es',
    urlPath: '023540-Ib4NCUdcK90moSiY.mp3',
    description: '沙哑粗砺，威严有力，带有压迫感',
  },
  {
    id: 'Spanish_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'es',
    urlPath: '023541-b2pc900KrIthlSuu.mp3',
    description: '温润清澈，娓娓道来，极具叙事感',
  },
  {
    id: 'Spanish_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'es',
    urlPath: '023542-nHvRO09qBnWRaT7B.mp3',
    description: '明亮清晰，干脆利落，知性力量感',
  },
  {
    id: 'Spanish_ThoughtfulMan',
    name: 'Thoughtful Man',
    lang: 'es',
    urlPath: '023542-0Yf2ihoD65XX1jyT.mp3',
    description: '温润磁性，娓娓道来，亲切自然',
  },
  {
    id: 'Spanish_Strong-WilledBoy',
    name: 'Strong-willed Boy',
    lang: 'es',
    urlPath: '023543-AxxqwBNUOvc2JyNK.mp3',
    description: '清亮坚定，充满激情，热血',
  },
  {
    id: 'Spanish_SophisticatedLady',
    name: 'Sophisticated Lady',
    lang: 'es',
    urlPath: '023543-xiVIsA32b5xyV4xx.mp3',
    description: '略带沙哑，豪爽干练，自信笃定',
  },
  {
    id: 'Spanish_RationalMan',
    name: 'Rational Man',
    lang: 'es',
    urlPath: '023544-AE1GB5puYImVP2Iu.mp3',
    description: '低沉浑厚，从容不迫，严肃冷峻',
  },
  {
    id: 'Spanish_AnimeCharacter',
    name: 'Anime Character',
    lang: 'es',
    urlPath: '023544-H4AmUbfwUZ2KpEVj.mp3',
    description: '粗犷沙哑，急促多变，紧张氛围感',
  },
  {
    id: 'Spanish_Deep-tonedMan',
    name: 'Deep-toned Man',
    lang: 'es',
    urlPath: '023545-ROXFVkajQmAUqed2.mp3',
    description: '浑厚，抑扬顿挫，反派魅力',
  },
  {
    id: 'Spanish_Fussyhostess',
    name: 'Fussy hostess',
    lang: 'es',
    urlPath: '023546-Q0eO16KLfkuZPs4l.mp3',
    description: '尖锐高亢，急促迫切，傲慢且挑剔',
  },
  {
    id: 'Spanish_SincereTeen',
    name: 'Sincere Teen',
    lang: 'es',
    urlPath: '023546-reoL1uJoFl6GC2bJ.mp3',
    description: '清脆明亮，节奏急促，充满吐槽感',
  },
  {
    id: 'Spanish_FrankLady',
    name: 'Frank Lady',
    lang: 'es',
    urlPath: '023547-gOHw5cUF9pVZ9XKb.mp3',
    description: '明亮尖锐，节奏急促，极具戏剧张力',
  },
  {
    id: 'Spanish_Comedian',
    name: 'Comedian',
    lang: 'es',
    urlPath: '023547-GEBQGJudgSwY6hlr.mp3',
    description: '高亢明快，抑扬顿挫，幽默诙谐',
  },
  {
    id: 'Spanish_Debator',
    name: 'Debator',
    lang: 'es',
    urlPath: '023548-Iw8yDr8KKehqiICn.mp3',
    description: '沙哑粗砺，抑扬顿挫，狡黠匪气',
  },
  {
    id: 'Spanish_ToughBoss',
    name: 'Tough Boss',
    lang: 'es',
    urlPath: '023549-gfaDLlRSLkg5z1NF.mp3',
    description: '低沉沙哑，极具戏剧张力，严肃厚重',
  },
  {
    id: 'Spanish_Wiselady',
    name: 'Wise Lady',
    lang: 'es',
    urlPath: '023549-NhilRqfGcpdzhcmm.mp3',
    description: '清亮优雅，节奏精准，神秘引导感',
  },
  {
    id: 'Spanish_Steadymentor',
    name: 'Steady Mentor',
    lang: 'es',
    urlPath: '023550-EDeNaCiGjAP5MAZq.mp3',
    description: '粗砺沙哑，戏剧夸张，凶狠狂妄',
  },
  {
    id: 'Spanish_Jovialman',
    name: 'Jovial Man',
    lang: 'es',
    urlPath: '023550-JKTxBo3wTcQUyz48.mp3',
    description: '略带沙哑，慵懒随性，乐天搞怪',
  },
  {
    id: 'Spanish_SantaClaus',
    name: 'Santa Claus',
    lang: 'es',
    urlPath: '023551-IYp1oO2qHlX4q292.mp3',
    description: '浑厚洪亮，抑扬顿挫，和蔼可亲',
  },
  {
    id: 'Spanish_Rudolph',
    name: 'Rudolph',
    lang: 'es',
    urlPath: '023551-LPDeSMYow18PYDFz.mp3',
    description: '稚嫩鼻音，迟缓笨拙，纯真童趣',
  },
  {
    id: 'Spanish_Intonategirl',
    name: 'Intonate Girl',
    lang: 'es',
    urlPath: '023552-1GjbbFjbowxM0PlR.mp3',
    description: '清脆明亮，节奏轻快跳跃，戏剧张力',
  },
  {
    id: 'Spanish_Arnold',
    name: 'Arnold',
    lang: 'es',
    urlPath: '023553-eF9e7baLzy9Et4ig.mp3',
    description: '低沉沙哑，娓娓道来，阅历感',
  },
  {
    id: 'Spanish_Ghost',
    name: 'Ghost',
    lang: 'es',
    urlPath: '023553-dzucbNvkf32xY4b9.mp3',
    description: '粗犷沙哑，干练急促，战场实况感',
  },
  {
    id: 'Spanish_HumorousElder',
    name: 'Humorous Elder',
    lang: 'es',
    urlPath: '023554-KmTEMUn7GdeldzYD.mp3',
    description: '沙哑滑稽，夸张起伏，喜剧画面感',
  },
  {
    id: 'Spanish_EnergeticBoy',
    name: 'Energetic Boy',
    lang: 'es',
    urlPath: '023554-CSg3ODUyLLqGanVT.mp3',
    description: '清脆明亮，轻快活泼，充满朝气',
  },
  {
    id: 'Spanish_WhimsicalGirl',
    name: 'Whimsical Girl',
    lang: 'es',
    urlPath: '023555-YWZPmzxOSA8Xw0HH.mp3',
    description: '甜美细腻，轻快灵动，古灵精怪',
  },
  {
    id: 'Spanish_StrictBoss',
    name: 'Strict Boss',
    lang: 'es',
    urlPath: '023556-kjzyEN7PJrxMTPtX.mp3',
    description: '硬朗有力，干脆利落，严厉紧迫',
  },
  {
    id: 'Spanish_ReliableMan',
    name: 'Reliable Man',
    lang: 'es',
    urlPath: '023556-dBGKJYx09FSvxdwn.mp3',
    description: '低沉浑厚，从容不迫，沉稳与睿智',
  },
  {
    id: 'Spanish_SereneElder',
    name: 'Serene Elder',
    lang: 'es',
    urlPath: '023557-fSkeYGVJ4AiWl3cZ.mp3',
    description: '苍老沙哑，节奏缓慢，充满戏剧张力',
  },
  {
    id: 'Spanish_AngryMan',
    name: 'Angry Man',
    lang: 'es',
    urlPath: '023558-MQHh9Yhhq9Uas3M7.mp3',
    description: '紧绷高亢，急促激烈，歇斯底里',
  },
  {
    id: 'Spanish_AssertiveQueen',
    name: 'Assertive Queen',
    lang: 'es',
    urlPath: '023558-Ka9K18YEWKSOcaNB.mp3',
    description: '清亮锐利，干脆利落，高冷且果断',
  },
  {
    id: 'Spanish_CaringGirlfriend',
    name: 'Caring Girlfriend',
    lang: 'es',
    urlPath: '023559-NrZJXllgUHejnWds.mp3',
    description: '甜美柔和，舒缓流畅，邻家亲切感',
  },
  {
    id: 'Spanish_PowerfulSoldier',
    name: 'Powerful Soldier',
    lang: 'es',
    urlPath: '023600-P8j8UXms7VuA5Ta7.mp3',
    description: '刚毅有力，干脆利落，极具战斗感',
  },
  {
    id: 'Spanish_PassionateWarrior',
    name: 'Passionate Warrior',
    lang: 'es',
    urlPath: '023600-YC9ZTGGKy8FykOMZ.mp3',
    description: '清朗，紧凑有力，热血',
  },
  {
    id: 'Spanish_ChattyGirl',
    name: 'Chatty Girl',
    lang: 'es',
    urlPath: '023601-CEPhIwDh90yqVFdq.mp3',
    description: '甜美明亮，轻快跳跃，邻家女孩般的陪伴感',
  },
  {
    id: 'Spanish_RomanticHusband',
    name: 'Romantic Husband',
    lang: 'es',
    urlPath: '023601-NhgYa8MMrgSxQWpp.mp3',
    description: '自然松弛，随意慵懒，愤世嫉俗',
  },
  {
    id: 'Spanish_CompellingGirl',
    name: 'Compelling Girl',
    lang: 'es',
    urlPath: '023602-tVfrkAIAGQNetWga.mp3',
    description: '清亮坚定，干脆利落，自信果敢',
  },
  {
    id: 'Spanish_PowerfulVeteran',
    name: 'Powerful Veteran',
    lang: 'es',
    urlPath: '023603-5d5QbmgmFbQvDdP8.mp3',
    description: '低沉粗砺，强硬有力，充满压迫感',
  },
  {
    id: 'Spanish_SensibleManager',
    name: 'Sensible Manager',
    lang: 'es',
    urlPath: '023603-2MoE3so00dplcOso.mp3',
    description: '略带沙哑，节奏急促，焦急恳切',
  },
  {
    id: 'Spanish_ThoughtfulLady',
    name: 'Thoughtful Lady',
    lang: 'es',
    urlPath: '023604-JuLGY50AbXO2y9si.mp3',
    description: '柔和细腻，舒缓自然，生活化',
  },
  {
    id: 'Portuguese_SentimentalLady',
    name: 'Sentimental Lady',
    lang: 'pt',
    urlPath: '023610-KjhxNBSA2pnBswkP.mp3',
    description: '尖锐明亮，夸张多变，傲慢且神经质',
  },
  {
    id: 'Portuguese_BossyLeader',
    name: 'Bossy Leader',
    lang: 'pt',
    urlPath: '023610-0fFgllSSUotuFCGj.mp3',
    description: '低沉沙哑，强硬有力，严肃冷峻',
  },
  {
    id: 'Portuguese_Wiselady',
    name: 'Wise lady',
    lang: 'pt',
    urlPath: '023611-oJMnxOiVgSzT1JcV.mp3',
    description: '清晰明亮，从容不迫，具有引导性',
  },
  {
    id: 'Portuguese_Strong-WilledBoy',
    name: 'Strong-willed Boy',
    lang: 'pt',
    urlPath: '023612-bILs9PMKKCu5WjIg.mp3',
    description: '清朗坚定，抑扬顿挫，热血',
  },
  {
    id: 'Portuguese_Deep-VoicedGentleman',
    name: 'Deep-voiced Gentleman',
    lang: 'pt',
    urlPath: '023612-4CVEaAB1GScDHrbU.mp3',
    description: '低沉沙哑，张弛有度，极具戏剧张力',
  },
  {
    id: 'Portuguese_UpsetGirl',
    name: 'Upset Girl',
    lang: 'pt',
    urlPath: '023613-EZetLfCGe0TbrkkU.mp3',
    description: '轻柔细腻，缓慢迟疑，忧郁歉意',
  },
  {
    id: 'Portuguese_PassionateWarrior',
    name: 'Passionate Warrior',
    lang: 'pt',
    urlPath: '023614-f4FIrDvRy32hLgIk.mp3',
    description: '清亮激昂，节奏紧凑，热血自信',
  },
  {
    id: 'Portuguese_AnimeCharacter',
    name: 'Anime Character',
    lang: 'pt',
    urlPath: '023614-04bYfo2qrchUwDrL.mp3',
    description: '高亢明亮，急促紧凑，充满戏剧张力',
  },
  {
    id: 'Portuguese_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'pt',
    urlPath: '023615-xEqbDkydOV6sAfSm.mp3',
    description: '明亮穿透，坚定有力，自信且充满气场',
  },
  {
    id: 'Portuguese_AngryMan',
    name: 'Angry Man',
    lang: 'pt',
    urlPath: '023616-WTq5MAo7YU0Og4pL.mp3',
    description: '紧绷且略带沙哑，节奏急促，极具对抗性',
  },
  {
    id: 'Portuguese_CaptivatingStoryteller',
    name: 'Captivating Storyteller',
    lang: 'pt',
    urlPath: '023616-fUk9LRS7tcBa4sCc.mp3',
    description: '低沉浑厚，娓娓道来，充满叙事感',
  },
  {
    id: 'Portuguese_Godfather',
    name: 'Godfather',
    lang: 'pt',
    urlPath: '023617-sKJ23S5ctUUM1WYG.mp3',
    description: '沙哑低沉，缓慢凝重，充满压迫感',
  },
  {
    id: 'Portuguese_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'pt',
    urlPath: '023617-SScLzCaz1rxYET3f.mp3',
    description: '纯净透亮，彬彬有礼，内敛真诚',
  },
  {
    id: 'Portuguese_SmartYoungGirl',
    name: 'Smart Young Girl',
    lang: 'pt',
    urlPath: '023618-mCDEbVOSZhT7ozcz.mp3',
    description: '高昂清脆，灵动活泼，机灵古怪',
  },
  {
    id: 'Portuguese_Kind-heartedGirl',
    name: 'Kind-hearted Girl',
    lang: 'pt',
    urlPath: '023619-vrQI9GnnQeGqwwDn.mp3',
    description: '清澈甜美，轻快流畅，积极阳光',
  },
  {
    id: 'Portuguese_Pompouslady',
    name: 'Pompous lady',
    lang: 'pt',
    urlPath: '023619-Tbq0uikOUzKigOdS.mp3',
    description: '高亢尖锐，矫揉造作，傲慢',
  },
  {
    id: 'Portuguese_Grinch',
    name: 'Grinch',
    lang: 'pt',
    urlPath: '023620-yIVojDwWvzQDvcr8.mp3',
    description: '沙哑粗砺，夸张多变，滑稽狡黠',
  },
  {
    id: 'Portuguese_Debator',
    name: 'Debator',
    lang: 'pt',
    urlPath: '023620-6frjTE62Uv1Xt7An.mp3',
    description: '沙哑粗砺，松弛痞气，狡黠市侩',
  },
  {
    id: 'Portuguese_SweetGirl',
    name: 'Sweet Girl',
    lang: 'pt',
    urlPath: '023621-smxRKWmWU11DvSIC.mp3',
    description: '甜美娇俏，夸张戏剧化，虚荣傲慢',
  },
  {
    id: 'Portuguese_AttractiveGirl',
    name: 'Attractive Girl',
    lang: 'pt',
    urlPath: '023622-OW01hxAjauxxvfSf.mp3',
    description: '甜美细腻，自然随性，邻家女孩感',
  },
  {
    id: 'Portuguese_ThoughtfulMan',
    name: 'Thoughtful Man',
    lang: 'pt',
    urlPath: '023622-B8ZdECvv3JjLMn61.mp3',
    description: '清亮干净，节奏轻快，诚恳活力',
  },
  {
    id: 'Portuguese_PlayfulGirl',
    name: 'Playful Girl',
    lang: 'pt',
    urlPath: '023623-ywsh9fxJ8Ddz5W5B.mp3',
    description: '甜美清亮，灵动活泼，元气少女感',
  },
  {
    id: 'Portuguese_GorgeousLady',
    name: 'Gorgeous Lady',
    lang: 'pt',
    urlPath: '023623-laHyJy1Dsl3F7pPD.mp3',
    description: '妩媚动人，娓娓道来，慵懒高贵',
  },
  {
    id: 'Portuguese_LovelyLady',
    name: 'Lovely Lady',
    lang: 'pt',
    urlPath: '023624-gHoT5vN77ZiBI4fL.mp3',
    description: '略带沙哑，干脆利落，具有统御力',
  },
  {
    id: 'Portuguese_SereneWoman',
    name: 'Serene Woman',
    lang: 'pt',
    urlPath: '023625-9iB6BbccUoKPfFzZ.mp3',
    description: '明亮清晰，节奏灵活，舞台表演感',
  },
  {
    id: 'Portuguese_SadTeen',
    name: 'Sad Teen',
    lang: 'pt',
    urlPath: '023625-UYsZro9HXO1pcPnw.mp3',
    description: '略带沙哑，节奏急促，充满了讽刺',
  },
  {
    id: 'Portuguese_MaturePartner',
    name: 'Mature Partner',
    lang: 'pt',
    urlPath: '023626-qIkiwxjPgPBTioh6.mp3',
    description: '粗砺沙哑，抑扬顿挫，爱发牢骚',
  },
  {
    id: 'Portuguese_Comedian',
    name: 'Comedian',
    lang: 'pt',
    urlPath: '023627-GSc5JcyqojmB7zej.mp3',
    description: '高亢明亮，抑扬顿挫，幽默滑稽',
  },
  {
    id: 'Portuguese_NaughtySchoolgirl',
    name: 'Naughty Schoolgirl',
    lang: 'pt',
    urlPath: '023627-A2ZUV8ELRw1Dt9R1.mp3',
    description: '清脆甜美，轻快跳跃，俏皮可爱',
  },
  {
    id: 'Portuguese_Narrator',
    name: 'Narrator',
    lang: 'pt',
    urlPath: '023628-p9DwywVd6pTTGSc3.mp3',
    description: '温暖亲切，轻快活泼，热情感染力',
  },
  {
    id: 'Portuguese_ToughBoss',
    name: 'Tough Boss',
    lang: 'pt',
    urlPath: '023628-S1cw579NNkXgJRxk.mp3',
    description: '略带沙哑，沉稳严肃，充满故事感',
  },
  {
    id: 'Portuguese_Fussyhostess',
    name: 'Fussy hostess',
    lang: 'pt',
    urlPath: '023629-Hk9Ka0JcVPEhDaCT.mp3',
    description: '尖锐高亢，急促且充满压迫感，暴躁女王',
  },
  {
    id: 'Portuguese_Dramatist',
    name: 'Dramatist',
    lang: 'pt',
    urlPath: '023630-nk2GPUp2NhnbQjtl.mp3',
    description: '沙哑，张扬夸张，狂放不羁',
  },
  {
    id: 'Portuguese_Steadymentor',
    name: 'Steady Mentor',
    lang: 'pt',
    urlPath: '023630-OE6ApWAIUufolVio.mp3',
    description: '沙哑粗犷，抑扬顿挫，狂妄阴森',
  },
  {
    id: 'Portuguese_Jovialman',
    name: 'Jovial Man',
    lang: 'pt',
    urlPath: '023631-NIJwI4bUzt3o431S.mp3',
    description: '粗犷且略带沙哑，节奏轻松随意，滑稽且极具亲和力',
  },
  {
    id: 'Portuguese_CharmingQueen',
    name: 'Charming Queen',
    lang: 'pt',
    urlPath: '023631-fOW8tEkVqBZpYWGJ.mp3',
    description: '冷艳磁性，慵懒优雅，高冷神秘',
  },
  {
    id: 'Portuguese_SantaClaus',
    name: 'Santa Claus',
    lang: 'pt',
    urlPath: '023632-dJpn70TffPXesN6N.mp3',
    description: '浑厚洪亮，戏剧化，喜庆欢快',
  },
  {
    id: 'Portuguese_Rudolph',
    name: 'Rudolph',
    lang: 'pt',
    urlPath: '023633-gvCA2XeOc00e3pNv.mp3',
    description: '鼻音质感，略显稚嫩，卡通形象感',
  },
  {
    id: 'Portuguese_Arnold',
    name: 'Arnold',
    lang: 'pt',
    urlPath: '023633-e13sjbn9ZnO7Y7Ih.mp3',
    description: '浑厚低沉，从容不迫，亲历者叙事感',
  },
  {
    id: 'Portuguese_CharmingSanta',
    name: 'Charming Santa',
    lang: 'pt',
    urlPath: '023634-EezPMuH9Zow4rfbl.mp3',
    description: '低沉沙哑，抑扬顿挫，威严神秘',
  },
  {
    id: 'Portuguese_CharmingLady',
    name: 'Charming Lady',
    lang: 'pt',
    urlPath: '023654-myeqB9JTpE8xcQub.mp3',
    description: '气声饱满，耳边低语，性感撩人',
  },
  {
    id: 'Portuguese_Ghost',
    name: 'Ghost',
    lang: 'pt',
    urlPath: '023635-WZJ3HlA13ybNBg5g.mp3',
    description: '低沉沙哑，节奏干脆，冷静克制',
  },
  {
    id: 'Portuguese_HumorousElder',
    name: 'Humorous Elder',
    lang: 'pt',
    urlPath: '023635-2Afnr8Av44DaVJQS.mp3',
    description: '沙哑颤抖，夸张跳跃，诙谐幽默',
  },
  {
    id: 'Portuguese_CalmLeader',
    name: 'Calm Leader',
    lang: 'pt',
    urlPath: '023636-qPUby6z3vfU79Azg.mp3',
    description: '低沉粗犷，随意自然，街头江湖气',
  },
  {
    id: 'Portuguese_GentleTeacher',
    name: 'Gentle Teacher',
    lang: 'pt',
    urlPath: '023636-FxpbI6621PEJTTmt.mp3',
    description: '声线清澈，循循善诱，耐心讲解',
  },
  {
    id: 'Portuguese_EnergeticBoy',
    name: 'Energetic Boy',
    lang: 'pt',
    urlPath: '023637-rdbrpe78feSUnSs2.mp3',
    description: '阳光清爽，活力四射，邻家大男孩',
  },
  {
    id: 'Portuguese_ReliableMan',
    name: 'Reliable Man',
    lang: 'pt',
    urlPath: '023638-4JVtslQwlDPhxp7X.mp3',
    description: '低沉醇厚，娓娓道来，智者风范',
  },
  {
    id: 'Portuguese_SereneElder',
    name: 'Serene Elder',
    lang: 'pt',
    urlPath: '023638-dyfNLRhZqfadGlK7.mp3',
    description: '低沉沙哑，娓娓道来，故事感',
  },
  {
    id: 'Portuguese_GrimReaper',
    name: 'Grim Reaper',
    lang: 'pt',
    urlPath: '023639-PRAXNgDJbfnhxqnx.mp3',
    description: '低沉沙哑，节奏冷酷，阴郁恐怖',
  },
  {
    id: 'Portuguese_AssertiveQueen',
    name: 'Assertive Queen',
    lang: 'pt',
    urlPath: '023640-cRc5C3dSwOb5WSrf.mp3',
    description: '华丽富有质感，自信坚定，高贵冷艳',
  },
  {
    id: 'Portuguese_WhimsicalGirl',
    name: 'Whimsical Girl',
    lang: 'pt',
    urlPath: '023640-KB4umUwlB4jOXU1g.mp3',
    description: '清脆明亮，灵动多变，奇幻色彩',
  },
  {
    id: 'Portuguese_StressedLady',
    name: 'Stressed Lady',
    lang: 'pt',
    urlPath: '023641-f41vGni8JkSDq7T7.mp3',
    description: '颤抖且略带气声，急促不安，绝望且焦虑',
  },
  {
    id: 'Portuguese_FriendlyNeighbor',
    name: 'Friendly Neighbor',
    lang: 'pt',
    urlPath: '023641-FRKbAL1LcGTiIP7l.mp3',
    description: '清脆明亮，语速干脆，充满活力',
  },
  {
    id: 'Portuguese_CaringGirlfriend',
    name: 'Caring Girlfriend',
    lang: 'pt',
    urlPath: '023642-EswhjlXaPfXcv6qB.mp3',
    description: '甜美细腻，富有韵律感，亲切温柔',
  },
  {
    id: 'Portuguese_PowerfulSoldier',
    name: 'Powerful Soldier',
    lang: 'pt',
    urlPath: '023643-fqtk7zbO6S6zra4m.mp3',
    description: '沙哑爆发，紧凑有力，热血激昂',
  },
  {
    id: 'Portuguese_FascinatingBoy',
    name: 'Fascinating Boy',
    lang: 'pt',
    urlPath: '023643-F4Ijwiu3K8SkYaSd.mp3',
    description: '明亮，跳跃轻快，热情洋溢',
  },
  {
    id: 'Portuguese_RomanticHusband',
    name: 'Romantic Husband',
    lang: 'pt',
    urlPath: '023644-I2byYVILZ1LUOg9y.mp3',
    description: '略带沙哑，抑扬顿挫，愤世嫉俗',
  },
  {
    id: 'Portuguese_StrictBoss',
    name: 'Strict Boss',
    lang: 'pt',
    urlPath: '023644-OUZC237TQSmqFNO9.mp3',
    description: '清晰高亢，果断干脆，紧张专注',
  },
  {
    id: 'Portuguese_InspiringLady',
    name: 'Inspiring Lady',
    lang: 'pt',
    urlPath: '023645-MUWosEuO2gUd7mU1.mp3',
    description: '清脆甜美，充满活力，热情洋溢',
  },
  {
    id: 'Portuguese_PlayfulSpirit',
    name: 'Playful Spirit',
    lang: 'pt',
    urlPath: '023645-NMiff3aRWPdLwJXA.mp3',
    description: '高亢明亮，节奏急促，俏皮叛逆',
  },
  {
    id: 'Portuguese_ElegantGirl',
    name: 'Elegant Girl',
    lang: 'pt',
    urlPath: '023646-JquQiMW31DbOSlmh.mp3',
    description: '声线清脆尖细，节奏急促，富有戏剧张力',
  },
  {
    id: 'Portuguese_CompellingGirl',
    name: 'Compelling Girl',
    lang: 'pt',
    urlPath: '023647-8Gi7YmCdVHh9wu6r.mp3',
    description: '清晰坚实，节奏紧凑，指令感强',
  },
  {
    id: 'Portuguese_PowerfulVeteran',
    name: 'Powerful Veteran',
    lang: 'pt',
    urlPath: '023647-6qrVk0ZlXZsNIIW2.mp3',
    description: '粗砺深沉，缓慢坚定，上位者气息',
  },
  {
    id: 'Portuguese_SensibleManager',
    name: 'Sensible Manager',
    lang: 'pt',
    urlPath: '023648-0ZFPFTOlgsF3TDs6.mp3',
    description: '厚重且略带沙哑，充满情感起伏，忧心忡忡',
  },
  {
    id: 'Portuguese_ThoughtfulLady',
    name: 'Thoughtful Lady',
    lang: 'pt',
    urlPath: '023648-KHKPD10UE1t6NRjs.mp3',
    description: '柔和亲切，极具生活气息，充满关切',
  },
  {
    id: 'Portuguese_TheatricalActor',
    name: 'Theatrical Actor',
    lang: 'pt',
    urlPath: '023649-zmPOFchFXoCAmU5J.mp3',
    description: '浑厚粗犷，戏剧腔调浓郁，傲慢且充满威胁',
  },
  {
    id: 'Portuguese_FragileBoy',
    name: 'Fragile Boy',
    lang: 'pt',
    urlPath: '023650-I05PSCmHvZSdx9sd.mp3',
    description: '带有颤抖气声，节奏迟疑，脆弱',
  },
  {
    id: 'Portuguese_ChattyGirl',
    name: 'Chatty Girl',
    lang: 'pt',
    urlPath: '023650-hiKvoDTwtZaTqEvQ.mp3',
    description: '甜美明亮，轻快活泼，邻家亲切感',
  },
  {
    id: 'Portuguese_Conscientiousinstructor',
    name: 'Conscientious Instructor',
    lang: 'pt',
    urlPath: '023651-ikGR2ApToBHoGdpq.mp3',
    description: '清脆明亮，轻快流畅，热情亲切',
  },
  {
    id: 'Portuguese_RationalMan',
    name: 'Rational Man',
    lang: 'pt',
    urlPath: '023652-dzYz6XXXhaSisQ5i.mp3',
    description: '低沉浑厚，缓慢从容，权威气质',
  },
  {
    id: 'Portuguese_WiseScholar',
    name: 'Wise Scholar',
    lang: 'pt',
    urlPath: '023652-MRUm9JFX4IqhqgCK.mp3',
    description: '清亮明快，干脆利落，邻家亲切感',
  },
  {
    id: 'Portuguese_FrankLady',
    name: 'Frank Lady',
    lang: 'pt',
    urlPath: '023653-S9OgWbcAexMA8Hzj.mp3',
    description: '略带沙哑，节奏急促，充满生活气息',
  },
  {
    id: 'Portuguese_DeterminedManager',
    name: 'Determined Manager',
    lang: 'pt',
    urlPath: '023653-nNSvMgZXkVvYuyrN.mp3',
    description: '尖锐且充满张力，节奏急促，严肃且具有对抗性',
  },
  {
    id: 'French_Male_Speech_New',
    name: 'Level-Headed Man',
    lang: 'fr',
    urlPath: '024007-uwVCzmQ7AiNSRJFw.mp3',
    description: '清晰明朗，娓娓道来，专家权威感',
  },
  {
    id: 'French_Female_News Anchor',
    name: 'Patient Female Presenter',
    lang: 'fr',
    urlPath: '024008-tH5mV018YEWPw5K3.mp3',
    description: '知性清晰，流畅自然，专业客观',
  },
  {
    id: 'French_CasualMan',
    name: 'Casual Man',
    lang: 'fr',
    urlPath: '024008-NXFYPhEsOVXVu837.mp3',
    description: '温润且富有质感，娓娓道来，具有思辨性',
  },
  {
    id: 'French_MovieLeadFemale',
    name: 'Movie Lead Female',
    lang: 'fr',
    urlPath: '024009-LN4RwbuX7Piav7bB.mp3',
    description: '清脆明亮，急促多变，情绪饱满',
  },
  {
    id: 'French_FemaleAnchor',
    name: 'Female Anchor',
    lang: 'fr',
    urlPath: '024009-BThZVUPyUDDxIouQ.mp3',
    description: '略带沙哑，娓娓道来，极具文艺感',
  },
  {
    id: 'French_MaleNarrator',
    name: 'Male Narrator',
    lang: 'fr',
    urlPath: '024010-XCbVTROxTADvDvpB.mp3',
    description: '清澈干净，娓娓道来，亲切自然',
  },
  {
    id: 'Indonesian_SweetGirl',
    name: 'Sweet Girl',
    lang: 'id',
    urlPath: '023950-zaHFZYe64g3oelka.mp3',
    description: '高亢明亮，戏剧化，自恋傲娇',
  },
  {
    id: 'Indonesian_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'id',
    urlPath: '023951-s0HJ4a6trMSEbHOZ.mp3',
    description: '干净清澈，娓娓道来，内敛深情',
  },
  {
    id: 'Indonesian_CharmingGirl',
    name: 'Charming Girl',
    lang: 'id',
    urlPath: '023953-zv75Rq7DWbsYwqda.mp3',
    description: '甜美细腻，自然随性，亲切邻家',
  },
  {
    id: 'Indonesian_CalmWoman',
    name: 'Calm Woman',
    lang: 'id',
    urlPath: '023954-0ist8KmbAUIuIluV.mp3',
    description: '清脆明亮，流畅自然，戏剧张力',
  },
  {
    id: 'Indonesian_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'id',
    urlPath: '023955-gf0HTBDxiJ1UvGgD.mp3',
    description: '明亮圆润，从容坚定，干练大方',
  },
  {
    id: 'Indonesian_CaringMan',
    name: 'Caring Man',
    lang: 'id',
    urlPath: '023957-JHdAsriECGR3Q2PQ.mp3',
    description: '富有磁性，抑扬顿挫，电影独白般',
  },
  {
    id: 'Indonesian_BossyLeader',
    name: 'Bossy Leader',
    lang: 'id',
    urlPath: '023958-kAb6KDgpk6wzmgkj.mp3',
    description: '低沉粗犷，语气强硬，战场指挥感',
  },
  {
    id: 'Indonesian_DeterminedBoy',
    name: 'Determined Boy',
    lang: 'id',
    urlPath: '023959-eNbU44GSpfPqLvFu.mp3',
    description: '清亮有力，坚定果敢，热血',
  },
  {
    id: 'Indonesian_GentleGirl',
    name: 'Gentle Girl',
    lang: 'id',
    urlPath: '024000-CNqe7t5EYXx2RvRw.mp3',
    description: '软糯轻柔，舒缓慵懒，呆萌',
  },
  {
    id: 'German_FriendlyMan',
    name: 'Friendly Man',
    lang: 'de',
    urlPath: '024118-1NbVddP3VHviwvLi.mp3',
    description: '轻松自然，如话家常，邻家感',
  },
  {
    id: 'German_SweetLady',
    name: 'Sweet Lady',
    lang: 'de',
    urlPath: '024119-p6xkeDxsO2VNRPgq.mp3',
    description: '轻柔细腻，舒缓流畅，忧郁深情',
  },
  {
    id: 'German_PlayfulMan',
    name: 'Playful Man',
    lang: 'de',
    urlPath: '024119-KYoEQ3vvVbYebZ3u.mp3',
    description: '自然清亮，轻快流畅，亲密交谈',
  },
  {
    id: 'Russian_HandsomeChildhoodFriend',
    name: 'Handsome Childhood Friend',
    lang: 'ru',
    urlPath: '024012-dLnnplkGbdCA31qb.mp3',
    description: '低沉沙哑，慵懒随意，耳边低语感',
  },
  {
    id: 'Russian_BrightHeroine',
    name: 'Bright Queen',
    lang: 'ru',
    urlPath: '024012-eAXKRuCslJfNkfh2.mp3',
    description: '略带沙哑，干脆利落，不羁野性',
  },
  {
    id: 'Russian_AmbitiousWoman',
    name: 'Ambitious Woman',
    lang: 'ru',
    urlPath: '024013-EERrvUcZyrRh08Cb.mp3',
    description: '略带沙哑，干练直爽，酷飒御姐感',
  },
  {
    id: 'Russian_ReliableMan',
    name: 'Reliable Man',
    lang: 'ru',
    urlPath: '024014-FvVY8sIyIgnfKouc.mp3',
    description: '低沉沙哑，沉稳有力，历尽沧桑',
  },
  {
    id: 'Russian_CrazyQueen',
    name: 'Crazy Girl',
    lang: 'ru',
    urlPath: '024014-ka4xds7COD2ZQjuc.mp3',
    description: '高亢明亮，充满爆发力，古灵精怪',
  },
  {
    id: 'Russian_PessimisticGirl',
    name: 'Pessimistic Girl',
    lang: 'ru',
    urlPath: '024015-SkIhRSDZYDVbZK8r.mp3',
    description: '清冷脆弱，克制不安，悲观内向',
  },
  {
    id: 'Russian_AttractiveGuy',
    name: 'Attractive Guy',
    lang: 'ru',
    urlPath: '024016-159apZ5QUujHgUy9.mp3',
    description: '低沉磁性，语调慵懒，霸道男友感',
  },
  {
    id: 'Russian_Bad-temperedBoy',
    name: 'Bad-tempered Boy',
    lang: 'ru',
    urlPath: '024016-zejePMKXbxUSPlHS.mp3',
    description: '稚嫩清亮，干脆利落，二次元画面感',
  },
  {
    id: 'Italian_BraveHeroine',
    name: 'Brave Heroine',
    lang: 'it',
    urlPath: '024017-hPPHfrIUPvykm5ed.mp3',
    description: '略带沙哑，干脆利落，高冷御姐',
  },
  {
    id: 'Italian_Narrator',
    name: 'Narrator',
    lang: 'it',
    urlPath: '024017-ZYqddZ5vjoRMO2uM.mp3',
    description: '低沉浑厚，娓娓道来，沉浸式',
  },
  {
    id: 'Italian_WanderingSorcerer',
    name: 'Wandering Sorcerer',
    lang: 'it',
    urlPath: '024018-jEa14l0gdXlvALOh.mp3',
    description: '低沉沙哑，慵懒随意，优雅神秘',
  },
  {
    id: 'Italian_DiligentLeader',
    name: 'Diligent Leader',
    lang: 'it',
    urlPath: '024019-YkSQPRVA2qNxAGhi.mp3',
    description: '略带沙哑，从容不迫，高傲且充满气场',
  },
  {
    id: 'Arabic_CalmWoman',
    name: 'Calm Woman',
    lang: 'ar',
    urlPath: '024045-Q5ppImEjIzukUdDZ.mp3',
    description: '柔和温润，娓娓道来，理性通透',
  },
  {
    id: 'Arabic_FriendlyGuy',
    name: 'Friendly Guy',
    lang: 'ar',
    urlPath: '024045-73csS4DhxPdMNkqW.mp3',
    description: '醇厚温暖，从容淡定，宠溺感',
  },
  {
    id: 'Turkish_CalmWoman',
    name: 'Calm Woman',
    lang: 'tr',
    urlPath: '024135-NSNSHkJMOAOvucnD.mp3',
    description: '柔和质感，舒缓流畅，沉稳亲和',
  },
  {
    id: 'Turkish_Trustworthyman',
    name: 'Trustworthy man',
    lang: 'tr',
    urlPath: '024136-yQRAKYEf3J5EuOFc.mp3',
    description: '低沉沙哑，娓娓道来，质朴真诚',
  },
  {
    id: 'Ukrainian_CalmWoman',
    name: 'Calm Woman',
    lang: 'uk',
    urlPath: '024136-D12gF8jqtLPn7aRu.mp3',
    description: '知性温婉，娓娓道来，治愈感',
  },
  {
    id: 'Ukrainian_WiseScholar',
    name: 'Wise Scholar',
    lang: 'uk',
    urlPath: '024137-dru2VfyptCtpgLPD.mp3',
    description: '清亮质朴，自然随性，亲切接地气',
  },
  {
    id: 'Dutch_kindhearted_girl',
    name: 'Kind-hearted girl',
    lang: 'nl',
    urlPath: '024046-SOjyvpD33sOdjyaP.mp3',
    description: '甜美细腻，清晰明快，温暖亲切',
  },
  {
    id: 'Dutch_bossy_leader',
    name: 'Bossy leader',
    lang: 'nl',
    urlPath: '024046-vC7UyRmS730DyLjC.mp3',
    description: '沙哑颗粒感，斩钉截铁，霸气外露',
  },
  {
    id: 'Vietnamese_kindhearted_girl',
    name: 'Kind-hearted girl',
    lang: 'vi',
    urlPath: '024042-3fNFMj71eB80jToe.mp3',
    description: '甜美细腻，轻快流畅，邻家女孩',
  },
  {
    id: 'Thai_male_1_sample8',
    name: 'Serene Man',
    lang: 'th',
    urlPath: '024036-G2iJ1a8mzNMjaKoj.mp3',
    description: '醇厚温润，娓娓道来，治愈感',
  },
  {
    id: 'Thai_male_2_sample2',
    name: 'Friendly Man',
    lang: 'th',
    urlPath: '024038-Jd7USrp0rMm07FAE.mp3',
    description: '明亮亲切，轻快流畅，极具亲和力',
  },
  {
    id: 'Thai_female_1_sample1',
    name: 'Confident Woman',
    lang: 'th',
    urlPath: '024039-gtavq4R2VyMh1PHe.mp3',
    description: '明亮，轻快流畅，自信',
  },
  {
    id: 'Thai_female_2_sample2',
    name: 'Energetic Woman',
    lang: 'th',
    urlPath: '024040-ujO09fptcEeUha5m.mp3',
    description: '清亮，条理清晰，充满活力',
  },
  {
    id: 'Polish_male_1_sample4',
    name: 'Male Narrator',
    lang: 'pl',
    urlPath: '024053-tl5lsGHd7njudEz2.mp3',
    description: '沉稳厚实，从容平缓，专业严谨',
  },
  {
    id: 'Polish_male_2_sample3',
    name: 'Male Anchor',
    lang: 'pl',
    urlPath: '024054-RkwPrSCtgSnl2m8j.mp3',
    description: '清亮，节奏极快，热情洋溢',
  },
  {
    id: 'Polish_female_1_sample1',
    name: 'Calm Woman',
    lang: 'pl',
    urlPath: '024054-gLB9vudK7PV0qO4G.mp3',
    description: '清晰柔和，娓娓道来，富有知识涵养',
  },
  {
    id: 'Polish_female_2_sample3',
    name: 'Casual Woman',
    lang: 'pl',
    urlPath: '024055-gXF4dKPld4mfhPs8.mp3',
    description: '温暖且自然，如同日常交谈，富有生活气息',
  },
  {
    id: 'Romanian_male_1_sample2',
    name: 'Reliable Man',
    lang: 'ro',
    urlPath: '024049-MkfSReSLivWJ0d40.mp3',
    description: '沉稳厚实，铿锵有力，权威感',
  },
  {
    id: 'Romanian_male_2_sample1',
    name: 'Energetic Youth',
    lang: 'ro',
    urlPath: '024049-QjilPl2HNX5imNBD.mp3',
    description: '清亮且略带沙哑质感，流畅自然，亲切且富有知识性',
  },
  {
    id: 'Romanian_female_1_sample4',
    name: 'Optimistic Youth',
    lang: 'ro',
    urlPath: '024050-KxDDs93wjftigXS5.mp3',
    description: '清脆明亮，轻快活泼，热情',
  },
  {
    id: 'Romanian_female_2_sample1',
    name: 'Gentle Woman',
    lang: 'ro',
    urlPath: '024050-9Sc17xwCKavEZNGh.mp3',
    description: '清亮悦耳，轻快流畅，亲切自然',
  },
  {
    id: 'greek_male_1a_v1',
    name: 'Thoughtful Mentor',
    lang: 'el',
    urlPath: '024052-kQZF4vCIJ25qrmQw.mp3',
    description: '清亮亲切，自然流畅，轻松活泼',
  },
  {
    id: 'Greek_female_1_sample1',
    name: 'Gentle Lady',
    lang: 'el',
    urlPath: '024051-XJyGyBQA327d9nVJ.mp3',
    description: '柔和细腻，娓娓道来，叙述感',
  },
  {
    id: 'Greek_female_2_sample3',
    name: 'Girl Next Door',
    lang: 'el',
    urlPath: '024053-J38BafWr6GMZxLhU.mp3',
    description: '清亮自然，语速轻快，随性幽默',
  },
  {
    id: 'czech_male_1_v1',
    name: 'Assured Presenter',
    lang: 'cs',
    urlPath: '024057-lOm9NuIedViF1d2T.mp3',
    description: '浑厚有力，抑扬顿挫，新闻现场感',
  },
  {
    id: 'czech_female_5_v7',
    name: 'Steadfast Narrator',
    lang: 'cs',
    urlPath: '024058-yy8cYuxXW929MkBu.mp3',
    description: '清晰明亮，紧凑流畅，现场报道感',
  },
  {
    id: 'czech_female_2_v2',
    name: 'Elegant Lady',
    lang: 'cs',
    urlPath: '024058-oysoir9xKCfZpbbR.mp3',
    description: '清脆明亮，轻快流畅，亲切自然',
  },
  {
    id: 'finnish_male_3_v1',
    name: 'Upbeat Man',
    lang: 'fi',
    urlPath: '024059-YuXBDsmmX69BCwXd.mp3',
    description: '清亮自然，轻快流畅，日常交谈感',
  },
  {
    id: 'finnish_male_1_v2',
    name: 'Friendly Boy',
    lang: 'fi',
    urlPath: '024100-5Gim1Irg3kW5jbOj.mp3',
    description: '明朗亲切，轻快流畅，邻家朋友感',
  },
  {
    id: 'finnish_female_4_v1',
    name: 'Assertive Woman',
    lang: 'fi',
    urlPath: '024059-bxEOdvFXTsEFZcTb.mp3',
    description: '清脆有力，节奏紧凑，新闻现场感',
  },
  {
    id: 'hindi_male_1_v2',
    name: 'Trustworthy Advisor',
    lang: 'hi',
    urlPath: '024120-NWIy28BAP8AZbFZ4.mp3',
    description: '厚实，娓娓道来，亲切自然',
  },
  {
    id: 'hindi_female_2_v1',
    name: 'Tranquil Woman',
    lang: 'hi',
    urlPath: '024121-WbsmGslvkdYYWzXq.mp3',
    description: '温暖沉静，娓娓道来，极具画面感',
  },
  {
    id: 'hindi_female_1_v2',
    name: 'News Anchor',
    lang: 'hi',
    urlPath: '024123-jIFEld5OG6S17Yen.mp3',
    description: '清晰明亮，字正腔圆，新闻播报感',
  },
  { id: 'male-qn-qingse', name: 'Youthful Boy', lang: 'zh', urlPath: '064812-4Due0dDdeqTLIymh.mp3' },
  { id: 'male-qn-jingying', name: 'Elite Youth', lang: 'zh', urlPath: '064815-GR7u5RNgVVD2VEg8.mp3' },
  { id: 'male-qn-badao', name: 'Domineering Youth', lang: 'zh', urlPath: '064818-2yMMpiYMMMyurUyb.mp3' },
  { id: 'male-qn-daxuesheng', name: 'College Student', lang: 'zh', urlPath: '064821-LeFdIqLvTK0C54BI.mp3' },
  { id: 'female-shaonv', name: 'Young Girl', lang: 'zh', urlPath: '064824-m3R9yW1A2K3QDkt4.mp3' },
  { id: 'female-yujie', name: 'Mature Lady', lang: 'zh', urlPath: '064827-legOVONYeewtmKfM.mp3' },
  { id: 'female-chengshu', name: 'Mature Woman', lang: 'zh', urlPath: '064830-YQeb50umCMNhqB4g.mp3' },
  { id: 'female-tianmei', name: 'Sweet Woman', lang: 'zh', urlPath: '064833-uO4NWlMlWekbEcbF.mp3' },
  { id: 'male-qn-qingse-jingpin', name: 'Youthful Boy Beta', lang: 'zh', urlPath: '064836-q343BsnlDkoluOh7.mp3' },
  { id: 'male-qn-jingying-jingpin', name: 'Elite Youth Beta', lang: 'zh', urlPath: '064839-geJ9vnzST9ZhZEQd.mp3' },
  { id: 'male-qn-badao-jingpin', name: 'Domineering Youth Beta', lang: 'zh', urlPath: '064842-QZq5vbXQO9S67BgE.mp3' },
  {
    id: 'male-qn-daxuesheng-jingpin',
    name: 'College Student Beta',
    lang: 'zh',
    urlPath: '064845-U7UwiNT3x0PqHG7T.mp3',
  },
  { id: 'female-shaonv-jingpin', name: 'Young Girl Beta', lang: 'zh', urlPath: '064848-YAAdLdRfGuKSS1LF.mp3' },
  { id: 'female-yujie-jingpin', name: 'Mature Lady Beta', lang: 'zh', urlPath: '064850-8A84uIAV5kSrK2Fd.mp3' },
  { id: 'female-chengshu-jingpin', name: 'Mature Woman Beta', lang: 'zh', urlPath: '064853-BeA9FXudddP852IB.mp3' },
  { id: 'female-tianmei-jingpin', name: 'Sweet Woman Beta', lang: 'zh', urlPath: '064856-tdEEvflBllXRbQa8.mp3' },
  { id: 'clever_boy', name: 'Clever Boy', lang: 'zh', urlPath: '064859-wrlqqwanj3kChi6w.mp3' },
  { id: 'cute_boy', name: 'Cute Boy', lang: 'zh', urlPath: '064903-eAuarhCBjfJtI636.mp3' },
  { id: 'lovely_girl', name: 'Lovely Girl', lang: 'zh', urlPath: '064906-SVirgqi2mDvPMwwn.mp3' },
  { id: 'cartoon_pig', name: 'Cartoon Pig', lang: 'zh', urlPath: '064909-MlCIH8Oa3NSIkFc6.mp3' },
  { id: 'bingjiao_didi', name: 'Yandere Brother', lang: 'zh', urlPath: '064911-xP9C7ou5Zaj2ckB4.mp3' },
  { id: 'junlang_nanyou', name: 'Handsome Boyfriend', lang: 'zh', urlPath: '064914-8JSI8BToZb0CrmIX.mp3' },
  { id: 'chunzhen_xuedi', name: 'Innocent Junior', lang: 'zh', urlPath: '064917-exbAx5UbZkVylCAn.mp3' },
  { id: 'lengdan_xiongzhang', name: 'Aloof Senior', lang: 'zh', urlPath: '064920-fk6Df4zVsKqB2hWo.mp3' },
  { id: 'badao_shaoye', name: 'Arrogant Young Master', lang: 'zh', urlPath: '064922-ceu9g1fXoqrp4eso.mp3' },
  { id: 'tianxin_xiaoling', name: 'Sweet Ling', lang: 'zh', urlPath: '064925-Nwc8nU6nPos2Zi1A.mp3' },
  { id: 'qiaopi_mengmei', name: 'Playful Cutie', lang: 'zh', urlPath: '064928-F2qw5GSSZXzDknPb.mp3' },
  { id: 'wumei_yujie', name: 'Charming Lady', lang: 'zh', urlPath: '064931-4VRJgFDLbBQWHmFH.mp3' },
  { id: 'diadia_xuemei', name: 'Coquettish Junior', lang: 'zh', urlPath: '064933-ERvaPRj2pXdoCVWs.mp3' },
  { id: 'danya_xuejie', name: 'Elegant Senior', lang: 'zh', urlPath: '064936-u7d9433KRVdaIJUU.mp3' },
  { id: 'Chinese (Mandarin)_News_Anchor', name: 'News Anchor', lang: 'zh', urlPath: '064939-g5BCjKnN5oH08PJe.mp3' },
  {
    id: 'Chinese (Mandarin)_HK_Flight_Attendant',
    name: 'HK Flight Attendant',
    lang: 'zh',
    urlPath: '064941-IyMiwHDE2ZKD64Jx.mp3',
  },
  {
    id: 'Cantonese_ProfessionalHost（M)',
    name: 'Professional Host (M)',
    lang: 'zhYue',
    urlPath: '064944-rh9YaF1ySNiVM3wr.mp3',
  },
  { id: 'Cantonese_PlayfulMan', name: 'Playful Man', lang: 'zhYue', urlPath: '064947-VOBN6xPjF9bq50lB.mp3' },
  { id: 'Santa_Claus', name: 'Santa Claus', lang: 'en', urlPath: '064949-V0WI9nAHQ85HPu18.mp3' },
  { id: 'Grinch', name: 'Grinch', lang: 'en', urlPath: '064952-iejHTYgBqtvRrz8H.mp3' },
  { id: 'Rudolph', name: 'Rudolph', lang: 'en', urlPath: '064955-AXRuJ1WnPEcajWm4.mp3' },
  { id: 'Arnold', name: 'Arnold', lang: 'en', urlPath: '064958-RJj1XZoJ9PD2CqT6.mp3' },
  { id: 'Charming_Santa', name: 'Charming Santa', lang: 'en', urlPath: '065002-HpLEeelj1cfUNIEO.mp3' },
  { id: 'Charming_Lady', name: 'Charming Lady', lang: 'en', urlPath: '065005-1NN83gXCCWXEX8Pl.mp3' },
  { id: 'Sweet_Girl', name: 'Sweet Girl', lang: 'en', urlPath: '065008-YbLmHoxt1mzO7YFx.mp3' },
  { id: 'Cute_Elf', name: 'Cute Elf', lang: 'en', urlPath: '065010-aDPCySWFJ0GmURWU.mp3' },
  { id: 'Attractive_Girl', name: 'Attractive Girl', lang: 'en', urlPath: '065013-FDenkMupho9EHhme.mp3' },
  { id: 'Serene_Woman', name: 'Serene Woman', lang: 'en', urlPath: '065016-mmdINNjSsHi4LvXu.mp3' },
  { id: 'English_BossyLeader', name: 'Bossy Leader', lang: 'en', urlPath: 'English_BossyLeader-82b8ee7e.mp3' },
  { id: 'English_Comedian', name: 'Comedian', lang: 'en', urlPath: 'English_Comedian-b556c039.mp3' },
  { id: 'English_Debator', name: 'Male Debater', lang: 'en', urlPath: 'English_Debator-362ee2be.mp3' },
  {
    id: 'English_Deep-VoicedGentleman',
    name: 'Deep-voiced Gentleman',
    lang: 'en',
    urlPath: 'English_Deep-VoicedGentleman-7e87b4cd.mp3',
  },
  { id: 'English_Jovialman', name: 'Jovial Man', lang: 'en', urlPath: 'English_Jovialman-ac0f9bbe.mp3' },
  { id: 'English_LovelyGirl', name: 'Lovely Girl', lang: 'en', urlPath: 'English_LovelyGirl-286a0328.mp3' },
  {
    id: 'English_MaturePartner',
    name: 'Mature Partner',
    lang: 'en',
    urlPath: 'English_MaturePartner-7adf6736.mp3',
  },
  {
    id: 'English_PassionateWarrior',
    name: 'Passionate Youth',
    lang: 'en',
    urlPath: 'English_PassionateWarrior-8cde9d19.mp3',
  },
  { id: 'English_PlayfulGirl', name: 'Playful Girl', lang: 'en', urlPath: 'English_PlayfulGirl-aa847fab.mp3' },
  {
    id: 'English_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'en',
    urlPath: 'English_ReservedYoungMan-c5224e77.mp3',
  },
  { id: 'English_SadTeen', name: 'Teen Boy', lang: 'en', urlPath: 'English_SadTeen-185b9dc0.mp3' },
  {
    id: 'English_SentimentalLady',
    name: 'Sentimental Lady',
    lang: 'en',
    urlPath: 'English_SentimentalLady-7d22830f.mp3',
  },
  {
    id: 'English_Trustworth_Man',
    name: 'Trustworthy Man',
    lang: 'en',
    urlPath: 'English_Trustworth_Man-be415fbd.mp3',
  },
  { id: 'English_UpsetGirl', name: 'Upset Girl', lang: 'en', urlPath: 'English_UpsetGirl-bd62dd81.mp3' },
  {
    id: 'English_Whispering_girl_v3',
    name: 'Whispering girl',
    lang: 'en',
    urlPath: 'English_Whispering_girl_v3-30cc6a6d.mp3',
  },
  { id: 'English_Wiselady', name: 'Wise Lady', lang: 'en', urlPath: 'English_Wiselady-2595b249.mp3' },
];
